
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ServiceOutwardTaxGrid extends Serenity.EntityGrid<ServiceOutwardTaxRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseTax'; }
        protected getIdProperty() { return ServiceOutwardTaxRow.idProperty; }
        protected getInsertPermission() { return ServiceOutwardTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return ServiceOutwardTaxRow.localTextPrefix; }
        protected getService() { return ServiceOutwardTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

    }
}